/**
|--------------------------------------------------
| Constants
|--------------------------------------------------
*/
export const PROFILE_BASIC_REQUEST = 'PROFILE_BASIC_REQUEST'
export const PROFILE_BASIC_FAILURE = 'PROFILE_BASIC_FAILURE'
export const PROFILE_BASIC_SUCCESS = 'PROFILE_BASIC_SUCCESS'

export const PROFILE_DETAIL_REQUEST = 'PROFILE_DETAIL_REQUEST'
export const PROFILE_DETAIL_FAILURE = 'PROFILE_DETAIL_FAILURE'
export const PROFILE_DETAIL_SUCCESS = 'PROFILE_DETAIL_SUCCESS'

export const COUNTRY_REQUEST = 'COUNTRY_REQUEST'
export const COUNTRY_SUCCESS = 'COUNTRY_SUCCESS'
export const COUNTRY_FAILURE = 'COUNTRY_FAILURE'

export const PROVINCE_REQUEST = 'PROVINCE_REQUEST'
export const PROVINCE_SUCCESS = 'PROVINCE_SUCCESS'
export const PROVINCE_FAILURE = 'PROVINCE_FAILURE'

export const DISTRICT_REQUEST = 'DISTRICT_REQUEST'
export const DISTRICT_SUCCESS = 'DISTRICT_SUCCESS'
export const DISTRICT_FAILURE = 'DISTRICT_FAILURE'

export const SAVE_PROFILE_DETAIL_REQUEST = 'SAVE_PROFILE_DETAIL_REQUEST'
export const SAVE_PROFILE_DETAIL_FAILURE = 'SAVE_PROFILE_DETAIL_FAILURE'
export const SAVE_PROFILE_DETAIL_SUCCESS = 'SAVE_PROFILE_DETAIL_SUCCESS'

export const UPLOAD_AVATAR_REQUEST = 'UPLOAD_AVATAR_REQUEST'
export const UPLOAD_AVATAR_FAILURE = 'UPLOAD_AVATAR_FAILURE'
export const UPLOAD_AVATAR_SUCCESS = 'UPLOAD_AVATAR_SUCCESS'

export const CONSTANTS = {
  PROFILE_BASIC_REQUEST,
  PROFILE_BASIC_FAILURE,
  PROFILE_BASIC_SUCCESS,
  PROFILE_DETAIL_REQUEST,
  PROFILE_DETAIL_FAILURE,
  PROFILE_DETAIL_SUCCESS,
  COUNTRY_REQUEST,
  COUNTRY_SUCCESS,
  COUNTRY_FAILURE,
  PROVINCE_REQUEST,
  PROVINCE_SUCCESS,
  PROVINCE_FAILURE,
  DISTRICT_REQUEST,
  DISTRICT_SUCCESS,
  DISTRICT_FAILURE,
  SAVE_PROFILE_DETAIL_REQUEST,
  SAVE_PROFILE_DETAIL_FAILURE,
  SAVE_PROFILE_DETAIL_SUCCESS,
  UPLOAD_AVATAR_REQUEST,
  UPLOAD_AVATAR_FAILURE,
  UPLOAD_AVATAR_SUCCESS
}

/**
|--------------------------------------------------
| Actions
|--------------------------------------------------
*/
export const getProfile = employeeId => ({
  type: PROFILE_BASIC_REQUEST,
  employeeId
})

export const getDetail = employeeId => ({
  type: PROFILE_DETAIL_REQUEST,
  employeeId
})

export const getProvinces = countryID => ({
  type: PROVINCE_REQUEST,
  countryID
})

export const getDistricts = provinceID => ({
  type: DISTRICT_REQUEST,
  provinceID
})

export const saveProfile = (employeeId, profile) => ({
  type: SAVE_PROFILE_DETAIL_REQUEST,
  profile,
  employeeId
})

export const uploadAvatar = blob => ({
  type: UPLOAD_AVATAR_REQUEST,
  blob
})

/**
|--------------------------------------------------
| Handlers
|--------------------------------------------------
*/
const ActionHandler = {
  [PROFILE_BASIC_REQUEST]: (currentState, action) => ({
    ...currentState,
    isLoading: true
  }),
  [PROFILE_BASIC_SUCCESS]: (currentState, action) => ({
    ...currentState,
    isLoading: false,
    profile: action.profile,
    leaveTypeSummary: action.leaveTypes,
    annualLeaveSummary: action.annualLeave,
    canEdit: action.canEdit,
    houseMaster: action.houseMaster
  }),
  [PROFILE_BASIC_FAILURE]: (currentState, action) => ({
    ...currentState,
    isLoading: false
  }),
  [PROFILE_DETAIL_SUCCESS]: (currentState, action) => ({
    ...currentState,
    detail: action.detail,
    houseMaster: action.houseMaster
  }),
  [COUNTRY_SUCCESS]: (currentState, action) => ({
    ...currentState,
    countries: action.countries
  }),
  [DISTRICT_SUCCESS]: (currentState, action) => ({
    ...currentState,
    districts: {
      ...currentState.districts,
      [action.provinceID]: action.districts
    }
  }),
  [PROVINCE_SUCCESS]: (currentState, action) => ({
    ...currentState,
    provinces: {
      ...currentState.provinces,
      [action.countryID]: action.provinces
    }
  }),
  [UPLOAD_AVATAR_REQUEST]: (currentState, action) => ({
    ...currentState,
    avatarUploading: true,
    fileBlob: action.blob
  }),
  [UPLOAD_AVATAR_FAILURE]: (currentState, action) => ({
    ...currentState,
    avatarUploading: false,
    avatarUploadSuccess: false
  }),
  [UPLOAD_AVATAR_SUCCESS]: (currentState, action) => ({
    ...currentState,
    avatarUploading: false,
    avatarUploadSuccess: true
  })
}

/**
|--------------------------------------------------
| Reducer
|--------------------------------------------------
*/
const initialState = {
  isLoading: false,
  avatarUploading: false,
  avatarUploadSuccess: false,
  fileBlob: null,
  profile: null,
  detail: null,
  leaveTypeSummary: [],
  annualLeaveSummary: null,
  houseMaster: null,
  countries: [],
  provinces: {},
  districts: {},
  canEdit: false
}

export default function profile(currentState = { ...initialState }, action) {
  const handler = ActionHandler[action.type]
  const nextState = handler ? handler(currentState, action) : currentState
  return nextState
}



// WEBPACK FOOTER //
// ./src/routes/UserProfile/modules/reducer.js